import { createHashRouter, RouterProvider } from 'react-router';

import { routes } from './routes';

const PersonvelgerCms: React.FC = () => {
  const router = createHashRouter(routes);

  return <RouterProvider router={router} />;
};

export default PersonvelgerCms;
